import type { Point } from 'geojson';

const RADIAN_CONVERT = 180;
const degreeToRadian = (degree: number) => (Math.PI * degree) / RADIAN_CONVERT;

export const calculateDistance = (
  lat1: number | undefined,
  lon1: number | undefined,
  lat2: number | undefined,
  lon2: number | undefined,
) => {
  if (lat1 === undefined || lon1 === undefined || lat2 === undefined || lon2 === undefined) return Number.MAX_SAFE_INTEGER;
  const lat1Radian = degreeToRadian(lat1);
  const lat2Radian = degreeToRadian(lat2);
  const distance = lon1 - lon2;
  const distanceRadian = degreeToRadian(distance);
  let dist = Math.sin(lat1Radian) * Math.sin(lat2Radian) + Math.cos(lat1Radian) * Math.cos(lat2Radian) * Math.cos(distanceRadian);
  if (dist > 1) {
    dist = 1;
  }
  dist = Math.acos(dist);
  dist = (dist * RADIAN_CONVERT) / Math.PI;
  // eslint-disable-next-line no-magic-numbers
  dist = dist * 60 * 1.1515;
  // eslint-disable-next-line no-magic-numbers
  dist *= 1.609344;
  return dist;
};

export const findMinDistance = (locations: Point[], origin: Point) => {
  const distances = locations.map(location =>
    calculateDistance(
      origin.coordinates?.[1],
      origin.coordinates?.[0],
      location.coordinates?.[1] as number,
      location.coordinates?.[0] as number,
    ),
  );
  return distances.length ? Math.min(...distances) : 0;
};

export const findMinDistanceIndex = (locations: Point[], origin: Point) => {
  const distances = locations.map(location =>
    calculateDistance(
      origin.coordinates?.[1],
      origin.coordinates?.[0],
      location.coordinates?.[1] as number,
      location.coordinates?.[0] as number,
    ),
  );
  const closestDistance = distances.length ? Math.min(...distances) : 0;
  return distances.length ? distances.indexOf(closestDistance) : 0;
};
